export default __webpack_public_path__ + "static/media/McquaidCrest.b861d190.png";